import React from "react";
import { object, string, array } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";

import "./photo-story-card.m.css";

const PhotoStoryCard = ({ story, imageType, aspectRatio, cardImageWidths, headlineStyle = "" }) => {
  return (
    <Link aria-label={story.headline} href={story.url} className="wrapper">
      <div styleName="base">
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          widths={cardImageWidths}
          imageType={imageType}
          zoom={false}
          showAlternateImage={true}
        />
        <div styleName="card-content" className="card-content">
          <NewsHeadline story={story} cssStyleName={headlineStyle} linkEnable={false} />
        </div>
      </div>
    </Link>
  );
};

PhotoStoryCard.defaultProps = {
  imageType: "image16x9",
  aspectRatio: [16, 9],
};

PhotoStoryCard.propTypes = {
  story: object.isRequired,
  imageType: string,
  aspectRatio: array,
  cardImageWidths: array,
  headlineStyle: string,
};

export default PhotoStoryCard;
